export default __webpack_public_path__ + "static/media/sketch15.66d000d0.png";